import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { reset_password_confirm } from '../actions/auth';

const ResetPasswordConfirm = ({ reset_password_confirm }) => {
    const { uid, token } = useParams();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({
        new_password: '',
        re_new_password: ''
    });

    const { new_password, re_new_password } = formData;

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = e => {
        e.preventDefault();
        reset_password_confirm(uid, token, new_password, re_new_password)
            .then(() => {
                // Clear the old token and force a re-login
                localStorage.removeItem('authToken');
                setShowSuccessModal(true);
            })
            .catch(err => {
                // Handle error
                setError('Password reset failed. Please try again.');
            });
    };

    // The login URL for the frontend
    const loginUrl = 'https://intelirain-app.com/login';

    return (
        <div className='container mt-5'>
            {/* Success Modal */}
            {showSuccessModal && (
                <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Success</h5>
                            </div>
                            <div className="modal-body">
                                <p>Password Changed Successfully</p>
                            </div>
                            <div className="modal-footer">
                                <a 
                                    href={loginUrl}
                                    className="btn btn-primary"
                                >
                                    Go to Login
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            
            {/* Form */}
            <form onSubmit={onSubmit}>
                <div className='form-group'>
                    <input
                        className='form-control'
                        type='password'
                        placeholder='New Password'
                        name='new_password'
                        value={new_password}
                        onChange={onChange}
                        minLength='6'
                        required
                    />
                </div>
                <div className='form-group'>
                    <input
                        className='form-control'
                        type='password'
                        placeholder='Confirm New Password'
                        name='re_new_password'
                        value={re_new_password}
                        onChange={onChange}
                        minLength='6'
                        required
                    />
                </div>
                {error && <div className="alert alert-danger">{error}</div>}
                <button className='btn btn-primary' type='submit'>Reset Password</button>
            </form>
        </div>
    );
};

export default connect(null, { reset_password_confirm })(ResetPasswordConfirm);